<div *ngIf="visibility" class="cand-modal welcome-modal">
    <article [@slideInOut] class="cand-modal__overlay cand-modal__overlay--welcome">
        <h1 class="cand-modal__title text-blue">
            <span
                >{{ 'modal.welcome.title' | i18n }}<span class="step-index">({{ currentStepIndex + 1 }}/{{ steps.length }})</span></span
            >
        </h1>
        <section class="cand-modal__content grid-container">
            <ul class="welcome-modal welcome-modal--list grid-12 centered">
                <li *ngFor="let step of steps; index as index" class="{{ 'grid-' + 12 / steps.length }} grid-mobile-4 welcome-modal__item">
                    <div
                        class="welcome-modal--item-wrapper"
                        [ngClass]="{
                            'welcome-modal__item--focused': currentStepIndex === index
                        }"
                    >
                        <div class="welcome-modal__item__image-wrapper">
                            <img
                                class="welcome-modal__item__image-wrapper--icon"
                                [ngClass]="{
                                    'welcome-modal__item--done': currentStepIndex > index
                                }"
                                alt=""
                                [appAssetSrc]="step.image"
                            />
                            <img *ngIf="currentStepIndex > index" class="welcome-modal__item__image-wrapper--checked hide-mobile" alt="" [appAssetSrc]="'assets/images/checked.svg'" />
                        </div>
                        <div
                            class="welcome-modal__item__text-wrapper"
                            [ngClass]="{
                                'welcome-modal__item__text-wrapper--focused': currentStepIndex === index,
                                'welcome-modal__item--done': currentStepIndex > index
                            }"
                        >
                            <span class="text-blue text-bold">{{ step.text | i18n }}</span>
                        </div>
                        <div class="welcome-modal__item__icon-info">
                            <em class=" "></em>
                        </div>
                    </div>
                    <em *ngIf="index !== steps.length" class="welcome-modal__separator"></em>
                </li>
            </ul>
            <div *ngIf="currentStepId === 'info_doc_download'" class="download-block grid-12 hide-mobile">
                <div class="download-block--info">
                    <span class="download-block--text" [innerHTML]="'modal.welcome.info1.info-doc-download' | i18n"></span>
                </div>
            </div>
            <div *ngIf="currentStepId === 'qs'" class="download-block grid-12 hide-mobile">
                <div class="download-block--info">
                    <span class="download-block--text" [innerHTML]="'modal.welcome.info1.medicalworkflow' | i18n"></span>
                    <span class="download-block--text" [innerHTML]="'modal.welcome.info2.medicalworkflow' | i18n"></span>
                </div>
            </div>
            <div *ngIf="currentStepId === 'signature_dad'" class="download-block grid-12 hide-mobile">
                <div class="download-block--info">
                    <span class="download-block--text" [innerHtml]="'modal.welcome.info1.signature' | i18n"></span>
                    <span class="download-block--text" [innerHtml]="'modal.welcome.info2.signature' | i18n"></span>
                </div>
            </div>
            <div class="welcome-modal__button-wrapper grid-12">
                <button id="startOrContinuStepsButton" class="button button--next button-interaction" data-tag-commander="" (click)="visibility = false" [appTagCommander]="'tagCo.welcomemodal.validate.button'">
                    <span *ngIf="currentStepIndex === 0">{{ 'modal.welcome.button.start' | i18n }}</span>
                    <span *ngIf="currentStepIndex > 0">{{ 'modal.welcome.button.continue' | i18n }}</span>
                </button>
            </div>
        </section>
        <span class="cand-modal__overlay__close circle-close-icon" data-tag-commander="" [appTagCommander]="'tagCo.welcomemodal.validate.button'" (click)="visibility = false"></span>
    </article>
    <div class="cand-modal__fade" *ngIf="visibility" [@fadeInOut] (click)="visibility = false"></div>
</div>
